import { Action, ActionType, State } from './types';
import _ from 'lodash';

export const initialState: State = {
  formErrors: {},
  isSubmitting: false,
  editingState: {
    productApiEnabled: false,
    preorderPeriod: '364',
    regionAndLocaleSets: [],
  },
  currentState: {
    productApiEnabled: false,
    preorderPeriod: '364',
    regionAndLocaleSets: [],
  },
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionType.SET_PRODUCT_API_ENABLED: {
      const { productApiEnabled } = action.payload;
      const { editingState } = state;
      return { ...state, editingState: { ...editingState, productApiEnabled } };
    }
    case ActionType.SET_PREORDER_PERIOD: {
      const { preorderPeriod } = action.payload;
      const { editingState } = state;
      return { ...state, editingState: { ...editingState, preorderPeriod } };
    }
    case ActionType.SET_CURRENT_STATE: {
      const { currentState } = action.payload;
      const clonedCurrentState = _.cloneDeep(currentState);
      return {
        ...state,
        formErrors: {},
        editingState: clonedCurrentState,
        currentState,
      };
    }
    case ActionType.CANCEL_CHANGES: {
      const { currentState } = state;
      const clonedCurrentState = _.cloneDeep(currentState);

      return {
        ...state,
        formErrors: {},
        editingState: clonedCurrentState,
        currentState,
      };
    }
    case ActionType.ADD_REGION_AND_LOCALE_SET: {
      const { regionAndLocaleSet: newRegionAndLocaleSet } = action.payload;
      const { editingState } = state;
      const exists = editingState.regionAndLocaleSets.some(
        (set) =>
          set.region === newRegionAndLocaleSet.region &&
          set.locale === newRegionAndLocaleSet.locale,
      );
      return exists
        ? state
        : {
            ...state,
            editingState: {
              ...editingState,
              regionAndLocaleSets: [
                ...editingState.regionAndLocaleSets,
                newRegionAndLocaleSet,
              ],
            },
          };
    }
    case ActionType.TOGGLE_REGION_AND_LOCALE_SET_ENABLED: {
      const { regionAndLocaleSet } = action.payload;
      const { editingState } = state;
      const { region, locale } = regionAndLocaleSet;
      return {
        ...state,
        editingState: {
          ...editingState,
          regionAndLocaleSets: editingState.regionAndLocaleSets.map((set) =>
            set.region === region && set.locale === locale
              ? { ...set, enabled: !set.enabled }
              : set,
          ),
        },
      };
    }
    case ActionType.SET_FORM_ERRORS: {
      const { formErrors } = action.payload;
      return { ...state, formErrors };
    }
    case ActionType.SET_IS_SUBMITTING: {
      const { isSubmitting } = action.payload;
      return { ...state, isSubmitting };
    }
  }
};

export default reducer;
